import React from "react";
import styles from "../../../styles/list-group-header.module.css";

function ListGroupHeader({ label }: { label: string }) {
  return (
    <div className={styles.listGroupHeader}>
      <span>{label}</span>
    </div>
  );
}

export default ListGroupHeader;
